import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { ProjectCommentsView } from "../features/memory/index.ts";
import { useAppParams } from "../shared/hooks/useAppParams.ts";

export const MemoryProjectComments: FC = () => {
  const { projectId } = useAppParams("MemoryProjectComments");

  return (
    <PageContainer>
      <ProjectCommentsView projectId={projectId} />
    </PageContainer>
  );
};
